import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store'

import { storeFreeze } from 'ngrx-store-freeze'

import { userActions } from 'shared-lib'

import { environment } from '../../environments/environment'

import * as fromReducers from './reducers'
import { effects as fromEffects } from './effects'

interface importType {
  [key: string]: { reducer: any }
}
export interface State {
  [key: string]: Record<string, any>[]
}

export const reducers: ActionReducerMap<State> = Object.keys(fromReducers)
  .sort()
  .reduce((prev, next: string) => {
    return { ...prev, ...{ [next]: (fromReducers as importType)[next].reducer } }
  }, {})

export const effects = Object.keys(fromEffects).map(effect => (fromEffects as any)[effect])

// A new sign-in — normal login, client switch, or Return — changes the active identity/customer.
// Reset every customer-scoped slice so nothing from the previous scope leaks into the next session;
// keep `user` (this action populates it) and the component-store bridge (per-component lifecycle).
// Token REFRESH dispatches OnIdTokenChanged, not OnLogIn, so this never fires on a background
// refresh — a switched session's banner and scope survive their hourly token refresh.
export function clearCustomerScopedState(reducer: ActionReducer<State>): ActionReducer<State> {
  return (state, action) => {
    if (action.type === userActions.OnLogIn.type && state) {
      const s = state as Record<string, unknown>
      const preserved: Record<string, unknown> = {}
      if (s.user) preserved.user = s.user
      if (s.componentStore) preserved.componentStore = s.componentStore
      state = preserved as State
    }
    return reducer(state, action)
  }
}

export const metaReducers: MetaReducer<State>[] = [clearCustomerScopedState, ...(!environment.production ? [storeFreeze] : [])]
